import { Component, Input, Output, EventEmitter } from '@angular/core';
import { range } from 'ramda';
import { REVIEW_CLASSES } from '../../constants';

@Component({
  selector: 'app-review-stars',
  templateUrl: './review-stars.component.html',
  styleUrls: ['./review-stars.component.scss']
})
export class ReviewStarsComponent {
  @Input() result;
  @Input() disabled: boolean;
  @Input() value: number;
  @Input() starSize: { width?: number; height?: number } = {
    width: 17,
    height: 16
  };
  @Output() submitRating = new EventEmitter();
  public readonly stars = range(0, 5);
  public readonly reviewClasses = REVIEW_CLASSES;
  public activeValue: number;

  setActiveValue(index: number) {
    if (!this.disabled) {
      this.activeValue = index;
    }
  }

  reSetActiveValue() {
    if (!this.disabled) {
      this.activeValue = null;
    }
  }

  getClasses(star): string | string[] {
    if (this.activeValue) {
      return this.getActiveValueClass(star);
    }

    if (this.value >= 0 && star + 1 <= this.value) {
      return [this.getClass(this.value), 'selected'];
    }
  }

  getClass(review): string {
    const result =
      typeof review === 'string'
        ? Math.floor(parseFloat(review)) - 1
        : Math.floor(review) - 1;
    return this.reviewClasses[result] || '';
  }

  getActiveValueClass(index) {
    return index <= this.activeValue
      ? this.reviewClasses[this.activeValue]
      : null;
  }
}
